import React from 'react';
import {
  Card,
  Box,
  Typography,
  Avatar,
  CardContent,
  CardActions,
  IconButton,
  useTheme,
} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

export default function BoardroomActivityCard({ activity }) {
  const getHeaderStyle = () => {
    switch (activity.activityType) {
      case 'advisorJoinedToCompany':
        return {
          backgroundColor: '#4FB5F9',
          color: 'white',
        };
      case 'advisorIdea':
        return {
          backgroundColor: '#D7DAFD',
          color: '#001030',
        };
    }
    return 'Activity';
  };
  const headerStyle = getHeaderStyle();
  const getHeaderText = () => {
    switch (activity.activityType) {
      case 'advisorJoinedToCompany':
        return 'New Board Member';
      case 'advisorIdea':
        return `Goal: “${activity.idea?.currentGoal}”`;
    }
    return 'Activity';
  };

  return (
    <>
      <Box
        sx={{
          // maxWidth: 600,
          width: '100%',
          borderRadius: '10px',
          // boxShadow: 1,
          bgcolor: 'background.paper',
          mt: 1,
          p: 1,
        }}
      >
        {/* Barra superior */}
        <Box
          sx={{
            ...headerStyle,
            borderRadius: '10px 10px 0 0',
            m: '-8px',
            py: '6px',
            px: '8px',
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              // maxWidth: '800px',
            }}
          >
            {getHeaderText()}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            // bgcolor: 'background.paper',
            mb: 1,
          }}
        >
          <Avatar
            src={`${process.env.REACT_APP_IMAGES_URL}${activity.advisor.image?.imageKey}`}
            alt={activity.advisor?.displayName}
            sx={{ width: 40, height: 40, mr: 2 }}
          />
          <Box>
            <Typography variant="subtitle1" component="div">
              {activity.advisor?.displayName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Advisor
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="body2"
          component="p"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {activity.label}
        </Typography>
      </Box>
      <Box
        sx={{
          px: 1,
          py: 0,
          display: 'flex',
          alignItems: 'left',
        }}
      >
        <IconButton size="small" aria-label="like">
          <ThumbUpIcon fontSize="small" />
        </IconButton>
        <Typography variant="body2" color="text.secondary">
          {activity.likes} {activity.likes === 1 ? 'like' : 'likes'}
        </Typography>
      </Box>
    </>
  );
}
